import Accordion from "../../component/template/Accordion";
import Breadcrumbs from "../../styles/components/Breadcrumbs";
import { Link } from "react-router-dom";
import "../../styles/pages/help/_faqs.scss";

export function FAQs() {
    return (
        <div className="faqs-page">
            <div className="faqs-page_container">
                <div className="faqs-page__header">
                    <Breadcrumbs
                        items={[
                            { label: "Home", href: "/" },
                            { label: "FAQs", href: "/faqs" },
                        ]}
                    />
                    <div className="faqs-page__title-row">
                        <h1 className="faqs-page__title">
                            Frequently asked questions
                        </h1>
                        <p className="faqs-page__sub">
                            Interview prep raises a lot of questions. Here are
                            the ones we hear most often. Still stuck? Browse the{" "}
                            <Link to="/help" className="faqs-page__link">
                                help centre
                            </Link>
                            .
                        </p>
                    </div>
                </div>

                <div className="faqs-page__body">
                    <Accordion />
                </div>
            </div>
        </div>
    );
}
